import { render, staticRenderFns } from "./MultipleOptionBox.vue?vue&type=template&id=44d20d06&"
import script from "./MultipleOptionBox.vue?vue&type=script&lang=js&"
export * from "./MultipleOptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports